module.exports = __webpack_public_path__ + "assets/img/wallet-icon1-s.c08a205e.png";